import React, { useEffect, useState } from "react";
import {
  BackButton,
  Box,
  ButtonStyled,
  LabelStyled,
  SubHeadingStyled,
  ThemeLoader,
} from "../../../../../components/styled/Elements";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ProfileWrapper } from "./styled";
import {
  Plus,
  SingleProfile,
} from "../../../../../components/styled/AllImages";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FormRadio from "../../../../../components/common/radioButtons/FormRadio";
import Breadcrumbs from "../../../../../components/admin/Breadcrumbs/Breadcrumbs";
import ValidatedInput from "../../../../../components/common/inputFields/ValidatedInput";
import CabinetsApi from "../../../../../services/api/cabinetsApi";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { ContentWrapper } from "../../../../../components/styled/styled";
import ValidationController from "../../../../../components/common/inputFields/ValidationController";
import AddMultipleUsers from "../../../../../components/common/modals/multipleUsersModal/AddMultipleUsers";
import AddSingleDepartment from "../../../../../components/common/modals/singleDepartmentModal/AddSingleDepartment";
import AddMultipleDepartments from "../../../../../components/common/modals/multipleDepartmentsModal/AddMultipleDepartments";
import { useSelector } from "react-redux";
import ValidationErrorText from "../../../../../components/common/inputFields/ValidationErrorText";
import { useUser } from "../../../../../context/userContext";
import CustomRadioButton from "../../../../../components/common/radioButtons/CustomRadio";
import { getIsTemporary } from "../../../../../utils";
import AddMultipleUsersBranchDep from "../../components/AddMultiUsersBranchDep";

const AddTemporaryFile = () => {
  const { user } = useUser();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { usersList, branchesDeps, hqBranchesList } = useSelector(
    (state) => state.helper
  );
  const navigate = useNavigate();
  // const location = useLocation();
  // const isTemporary = location.state?.is_temporary;

  const filteredUsers = usersList?.filter(
    (usr) => usr?.user_detail?.department_id == user?.department?.id
  );

  const isTemporary = 1;
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);
  const [radioOptions, setRadioOptions] = useState([]);
  const [userSelections, setUserSelections] = useState({
      branch_ids: [],
      department_ids: [],
      user_ids: [],
    });

  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    resetField,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      selected_ids: selectedIds,
      common_settings_id: 1,
    },
  });
  const fileType = watch("file_type");
  const checkSelectedValueID = watch("common_settings_id");

  const handleSingleSelect = (id) => {
    if (id) {
      setSelectedIds([id]); // Add single ID to the array
    } else {
      setSelectedIds([]); // Clear the array if no ID is selected
    }
  };
  const validateSelection = (value) => {
    if (
      [4, 5, 8, 9].includes(Number(checkSelectedValueID)) &&
      (!value || value.length === 0)
    ) {
      return t("Please_select_user");
    }
    if ([6, 7].includes(Number(checkSelectedValueID)) && !value) {
      return t("Please_select_department");
    }
    return true;
  };
  const getRadioData = async () => {
    try {
      setDataLoading(true);
      const response = await CabinetsApi.addCabinetRadio();
      if (response?.data?.length > 1) {
        const filteredOptions = response.data; // Skip the first option
        setRadioOptions([
          ...filteredOptions.map((option) => {
            if (option.id == 7 || option.id == 8) {
              return { ...option, description: "" };
            } else if (option.id == 6) {
              return {
                ...option,
                description: t("only_open_to_one_department_description"),
              };
            } else if (
              option.id == 2 ||
              option.id == 3 ||
              option.id == 4 ||
              option.id == 5
            ) {
              return {
                ...option,
                description: t("file_settings_description"),
              };
            } else if (option.id == 1) {
              return {
                ...option,
                title: t("based_on_cabinet_setting"),
                description: t("based_on_cabinet_setting_description"),
              };
            }
            return option;
          }),
        ]);
      }
    } catch (error) {
    } finally {
      setDataLoading(false);
    }
  };
  useEffect(() => {
    getRadioData();
  }, [language]);

  const onSubmit = async (formData) => {
    const updatedData = {
      ...formData,
      action: "create",
      // file_id: id,
      selected_ids: selectedIds,
      is_temporary: isTemporary && isTemporary,
      from_branches: userSelections.branch_ids,
      from_departments: userSelections.department_ids,
    };
    try {
      setLoading(true);
      const response = await CabinetsApi.createCabinetFile(id, updatedData);
      if (response.code === 200) {
        toast.success(t("file_created"));
        reset();
        navigate(`/temporary-cabinets/${id}/temporary-files`);
      }
      if (response.code === 100 || response.code === 204) {
        toast.error(response.message);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <ProfileWrapper>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Box className="content-head">
          <Box className="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 gap-md-5">
            <BackButton
              label={t("add_temporary_file")}
              onClick={() => navigate(`/temporary-cabinets/${id}/temporary-files`)}
            />
            <Breadcrumbs />
          </Box>
        </Box>

        <ContentWrapper>
          {dataLoading ? (
            <ThemeLoader />
          ) : (
            <>
              <Box>
                <ValidatedInput
                  name="name"
                  type="input"
                  fieldType="text"
                  placeholder={"FileName"}
                  label="FileName"
                  register={register}
                  staric={true}
                  errors={errors}
                  validationRules={{
                    required: true,
                  }}
                  className={"border-0"}
                />
                <ValidatedInput
                  name="description"
                  label="Description"
                  type="textarea"
                  placeholder={"Description"}
                  errors={errors}
                  register={register}
                  validationRules={{
                    required: false,
                  }}
                />
              </Box>

              <Box>
                {!isTemporary && (
                  <>
                    <Box className="innerFoHead">
                      <SubHeadingStyled size="16px" color="var(--text)">
                        {t("file_access_settings")}
                      </SubHeadingStyled>
                    </Box>
                    <Box className="optionsWrapper">
                      <Box className="">
                        {radioOptions?.slice(0, 1)?.map((x, i) => (
                          <Box
                            key={i}
                            className={`w-100 p-2 ${
                              i !== radioOptions.length - 1 &&
                              "separation-border"
                            }`}
                          >
                            <FormRadio
                              name="common_settings_id"
                              label={t(x.title)}
                              checked={checkSelectedValueID == x.id}
                              subLabel={t(x.description)}
                              value={x.id}
                              register={register}
                              validationRules={{
                                required: true,
                              }}
                              onClick={() => {
                                setSelectedIds(null);
                                resetField("selected_ids");
                              }}
                            />
                          </Box>
                        ))}
                      </Box>
                    </Box>
                    {/* Phase Two */}
                    <Box className="optionsWrapper">
                      <Box className="optionsContent">
                        <SubHeadingStyled
                          size="15px"
                          weight={700}
                          color={"var(--text)"}
                          className="px-4 pt-4 pb-0"
                        >
                          {t("my_department")}
                        </SubHeadingStyled>
                        {radioOptions?.slice(1, 5)?.map((x, i) => (
                          <Box
                            key={i}
                            className={`w-100 p-2 ${
                              i !== radioOptions.length - 1 &&
                              "separation-border"
                            }`}
                          >
                            <FormRadio
                              name="common_settings_id"
                              label={t(x.title)}
                              // subLabel={t(x.description)}
                              value={x.id}
                              register={register}
                              validationRules={{
                                required: true,
                              }}
                              onClick={() => {
                                setSelectedIds(null);
                                resetField("selected_ids");
                              }}
                            />
                            {checkSelectedValueID == 4 &&
                              x.id == checkSelectedValueID && (
                                <Box className="addUserCont">
                                  <ValidationController
                                    name="selected_ids"
                                    validationConfig={{
                                      validate: validateSelection,
                                    }}
                                    errors={errors}
                                    control={control}
                                    renderer={({ field }) => (
                                      <AddMultipleUsers
                                        title="add_users"
                                        icon={<SingleProfile />}
                                        selPlaceholder="SelectUser"
                                        mainParents={filteredUsers}
                                        setSelectedIds={(ids) => {
                                          field.onChange(ids);
                                          setSelectedIds(ids);
                                        }}
                                      />
                                    )}
                                  />
                                </Box>
                              )}
                            {checkSelectedValueID == 5 &&
                              x.id == checkSelectedValueID && (
                                <Box className="addUserCont">
                                  <ValidationController
                                    name="selected_ids"
                                    validationConfig={{
                                      validate: validateSelection,
                                    }}
                                    errors={errors}
                                    control={control}
                                    renderer={({ field }) => (
                                      <AddMultipleUsers
                                        title="add_users"
                                        icon={<SingleProfile />}
                                        selPlaceholder="SelectUser"
                                        mainParents={filteredUsers}
                                        setSelectedIds={(ids) => {
                                          field.onChange(ids);
                                          setSelectedIds(ids);
                                        }}
                                      />
                                    )}
                                  />
                                </Box>
                              )}
                          </Box>
                        ))}
                      </Box>
                    </Box>
                    {/* Phase Three */}
                    <Box className="optionsWrapper">
                      <Box className="optionsContent">
                        <SubHeadingStyled
                          size="15px"
                          weight={700}
                          color={"var(--text)"}
                          className="px-4 pt-4 pb-0"
                        >
                          {t("other_departments")}
                        </SubHeadingStyled>
                        {radioOptions?.slice(5, 9)?.map((x, i) => (
                          <Box
                            key={i}
                            className={`w-100 p-2 ${
                              i !== radioOptions.length - 1 &&
                              "separation-border"
                            }`}
                          >
                            <FormRadio
                              name="common_settings_id"
                              label={t(x.title)}
                              // subLabel={t(x.description)}
                              value={x.id}
                              register={register}
                              validationRules={{
                                required: true,
                              }}
                              onClick={() => {
                                setSelectedIds(null);
                                resetField("selected_ids");
                              }}
                            />

                            {checkSelectedValueID == 6 &&
                              x.id == checkSelectedValueID && (
                                <Box className="addUserCont">
                                  <ValidationController
                                    name="selected_ids"
                                    validationConfig={{
                                      validate: validateSelection,
                                    }}
                                    errors={errors}
                                    control={control}
                                    renderer={({ field }) => (
                                      <AddSingleDepartment
                                        title="select_department"
                                        icon={<Plus />}
                                        selPlaceholder="Select_One_Department"
                                        mainParents={branchesDeps}
                                        setSelectedItem={(ids) => {
                                          field.onChange(ids);
                                          setSelectedIds(ids);
                                        }}
                                      />
                                    )}
                                  />
                                </Box>
                              )}

                            {checkSelectedValueID == 7 &&
                              x.id == checkSelectedValueID && (
                                <Box className="addUserCont">
                                  <ValidationController
                                    name="selected_ids"
                                    validationConfig={{
                                      validate: validateSelection,
                                    }}
                                    errors={errors}
                                    control={control}
                                    renderer={({ field }) => (
                                      <AddMultipleDepartments
                                        title="select_department"
                                        icon={<Plus />}
                                        selPlaceholder="select_department"
                                        mainParents={branchesDeps}
                                        setSelectedIds={(ids) => {
                                          field.onChange(ids);
                                          setSelectedIds(ids);
                                        }}
                                      />
                                    )}
                                  />
                                </Box>
                              )}
                            {checkSelectedValueID == 8 &&
                              x.id == checkSelectedValueID && (
                                <Box className="addUserCont">
                                  <ValidationController
                                    name="selected_ids"
                                    validationConfig={{
                                      validate: validateSelection,
                                    }}
                                    errors={errors}
                                    control={control}
                                    renderer={({ field }) => (
                                      // <AddMultipleUsers
                                      //   title="add_users"
                                      //   icon={<SingleProfile />}
                                      //   selPlaceholder="SelectUser"
                                      //   mainParents={usersList}
                                      //   setSelectedIds={(ids) => {
                                      //     field.onChange(ids);
                                      //     setSelectedIds(ids);
                                      //   }}
                                      // />
                                      <AddMultipleUsersBranchDep
                                        title="select_department"
                                        icon={<Plus />}
                                        selPlaceholder="SelectUser"
                                        // mainParents={branchesDeps}
                                        setSelectedIds={(ids) => {
                                          field.onChange(ids);
                                          setSelectedIds(ids);
                                        }}
                                        hqBranchesList={hqBranchesList}
                                        usersList={usersList}
                                        branchesDeps={branchesDeps}
                                        userSelections={userSelections}
                                        setUserSelections={(selections) => {
                                          setUserSelections(selections);
                                          if (selections.user_ids?.length > 0) {
                                            field.onChange(
                                              selections?.user_ids
                                            );
                                            setSelectedIds(
                                              selections?.user_ids
                                            );
                                          }
                                        }}
                                      />
                                    )}
                                  />
                                </Box>
                              )}
                            {checkSelectedValueID == 9 &&
                              x.id == checkSelectedValueID && (
                                <Box className="addUserCont">
                                  <ValidationController
                                    name="selected_ids"
                                    validationConfig={{
                                      validate: validateSelection,
                                    }}
                                    errors={errors}
                                    control={control}
                                    renderer={({ field }) => (
                                      // <AddMultipleUsers
                                      //   title="add_users"
                                      //   icon={<SingleProfile />}
                                      //   selPlaceholder="SelectUser"
                                      //   mainParents={usersList}
                                      //   setSelectedIds={(ids) => {
                                      //     field.onChange(ids);
                                      //     setSelectedIds(ids);
                                      //   }}
                                      // />
                                      <AddMultipleUsersBranchDep
                                        title="select_department"
                                        icon={<Plus />}
                                        selPlaceholder="SelectUser"
                                        // mainParents={branchesDeps}
                                        // setSelectedIds={(ids) => {
                                        //   field.onChange(ids);
                                        //   setSelectedIds(ids);
                                        // }}
                                        setSelectedIds={(ids) => {
                                          field.onChange(ids);
                                          setSelectedIds(ids);
                                        }}
                                        hqBranchesList={hqBranchesList}
                                        usersList={usersList}
                                        branchesDeps={branchesDeps}
                                        userSelections={userSelections}
                                        setUserSelections={(selections) => {
                                          setUserSelections(selections);
                                          if (selections.user_ids?.length > 0) {
                                            field.onChange(
                                              selections?.user_ids
                                            );
                                            setSelectedIds(
                                              selections?.user_ids
                                            );
                                          }
                                        }}
                                      />
                                    )}
                                  />
                                </Box>
                              )}
                          </Box>
                        ))}
                      </Box>
                    </Box>
                    {/* Phase Four */}
                    <Box className="optionsWrapper">
                      <Box className="optionsContent">
                        <SubHeadingStyled
                          size="15px"
                          weight={700}
                          color={"var(--text)"}
                          className="px-4 pt-4 pb-0"
                        >
                          {t("myself")}
                        </SubHeadingStyled>
                        {radioOptions?.slice(9)?.map((x, i) => (
                          <Box
                            key={i}
                            className={`w-100 p-2 ${
                              i !== radioOptions.length - 1 &&
                              "separation-border"
                            }`}
                          >
                            <FormRadio
                              name="common_settings_id"
                              label={t(x.title)}
                              // subLabel={t(x.description)}
                              value={x.id}
                              register={register}
                              validationRules={{
                                required: true,
                              }}
                              onClick={() => {
                                setSelectedIds(null);
                                resetField("selected_ids");
                              }}
                            />
                          </Box>
                        ))}
                      </Box>
                    </Box>
                    <Box className="px-4">
                      {errors.common_settings_id?.type === "required" && (
                        <ValidationErrorText
                          text={
                            t(errors.common_settings_id?.message) ||
                            t("Pleaseselectone")
                          }
                        />
                      )}
                    </Box>
                  </>
                )}
                <Box className="d-flex justify-content-end">
                  <Box className="p-4 d-flex gap-3">
                    <ButtonStyled
                      label={t("Cancel")}
                      bg={"var(--bgSecondary)"}
                      color={"var(--text2)"}
                      type="button"
                      onClick={() => navigate(`/temporary-cabinets/${id}/temporary-files`)}
                    />
                    <ButtonStyled
                      label={t("Create")}
                      type="submit"
                      isLoading={loading}
                    />
                  </Box>
                </Box>
              </Box>
            </>
          )}
        </ContentWrapper>
      </Form>
    </ProfileWrapper>
  );
};

export default AddTemporaryFile;
